<section class="view-section">
  <bodyanalytics-section-rule [label]="label()"></bodyanalytics-section-rule>
  <div
    class="view-section__grid"
    [style.grid-template-columns]="'repeat(' + columns() + ', minmax(0, 1fr))'"
  >
    <ng-content></ng-content>
  </div>
</section>
